var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87109 0.5H16.1289C17.9915 0.5 19.5 2.00853 19.5 3.87109V16.1289C19.5 17.9915 17.9915 19.5 16.1289 19.5H3.87109C2.00853 19.5 0.5 17.9915 0.5 16.1289V3.87109C0.5 2.00853 2.00853 0.5 3.87109 0.5ZM2.08105 16.1289C2.08105 17.118 2.88205 17.9189 3.87109 17.9189H6.30664V13.6934H2.08105V16.1289ZM7.88672 17.9189H16.1289C17.118 17.9189 17.9189 17.118 17.9189 16.1289V13.6934H7.88672V17.9189ZM2.08105 12.1133H6.30664V7.88672H2.08105V12.1133ZM7.88672 12.1133H17.9189V7.88672H7.88672V12.1133ZM3.87109 2.08105C2.88205 2.08105 2.08105 2.88205 2.08105 3.87109V6.30664H6.30664V2.08105H3.87109ZM7.88672 6.30664H17.9189V3.87109C17.9189 2.88205 17.118 2.08105 16.1289 2.08105H7.88672V6.30664Z",
    fill: "#DC3A3F",
    stroke: "#E13E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.b84d0fd3e2943bbda954f5807f36bfcd.svg";
export { ForwardRef as ReactComponent };